// extracted by mini-css-extract-plugin
export var active = "social-media-module--active--f41dc";
export var annualEvents = "social-media-module--annual-events--e3767";
export var annualNews = "social-media-module--annual-news--bd522";
export var annualProjects = "social-media-module--annual-projects--2bd8b";
export var backgroundImage = "social-media-module--background-image--94a85";
export var btnAnchor = "social-media-module--btn-anchor--a854c";
export var btnClose = "social-media-module--btn-close--48d0c";
export var btnFacebook = "social-media-module--btn-facebook--8a439";
export var btnLinkedin = "social-media-module--btn-linkedin--df328";
export var btnOutlineLsuGold = "social-media-module--btn-outline-lsu-gold--a10dc";
export var btnOutlineLsuPurple = "social-media-module--btn-outline-lsu-purple--04d04";
export var btnPrimary = "social-media-module--btn-primary--b3916";
export var btnSecondary = "social-media-module--btn-secondary--c834a";
export var btnTwitter = "social-media-module--btn-twitter--040fd";
export var eventBlog = "social-media-module--event-blog--fe552";
export var h1 = "social-media-module--h1--bb3d2";
export var h2 = "social-media-module--h2--922c7";
export var h3 = "social-media-module--h3--07ad3";
export var h4 = "social-media-module--h4--19061";
export var h5 = "social-media-module--h5--54e43";
export var h6 = "social-media-module--h6--56d17";
export var hover = "social-media-module--hover--31ae0";
export var icon = "social-media-module--icon--8f5f4";
export var menu = "social-media-module--menu--2766c";
export var navLink = "social-media-module--nav-link--56548";
export var navbarDark = "social-media-module--navbar-dark--e2224";
export var navbarNav = "social-media-module--navbar-nav--33d8b";
export var navbarToggler = "social-media-module--navbar-toggler--c4099";
export var navbarTogglerIcon = "social-media-module--navbar-toggler-icon--82eb9";
export var newsArticle = "social-media-module--news-article--c3e7b";
export var newsEventsEvents = "social-media-module--news-events-events--6b1ee";
export var newsEventsNews = "social-media-module--news-events-news--22164";
export var pageItem = "social-media-module--page-item--e5b81";
export var pageLink = "social-media-module--page-link--11d54";
export var projectPost = "social-media-module--project-post--f72b8";
export var socialMedia = "social-media-module--social-media--355de";
export var textLight = "social-media-module--text-light--00f21";
export var textLsuLightGold = "social-media-module--text-lsu-light-gold--5499c";
export var textWhite = "social-media-module--text-white--27a77";
export var topNavigation = "social-media-module--top-navigation--91208";
export var underline = "social-media-module--underline--4e1a7";